import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFilterType, fetchTransactions } from "../../features/transaction/transactionsSlice";
import Styles from "../../assets/css/components/dashboard/dashboard.module.scss";
import Inbound from "../../assets/images/Dashboard/inbound.png";
import Outbound from "../../assets/images/Dashboard/outbound.png";
import { useNavigate } from "react-router-dom";
import ItemImage from "../../assets/images/itemImage.png";
import Loader from "../../utils/Loader";

const Dashboard = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { transactions, filterType, loading, error } = useSelector((state) => state.transactions);

    useEffect(() => {
        // Reset filter to "all" and fetch transactions when component mounts
        dispatch(setFilterType("all"));
        dispatch(fetchTransactions());
    }, [dispatch]);

    const handleScanBarcode = (type) => {
        navigate("/scanbarcode", { state: { scanType: type } });
    };

    const handleFilter = (type) => {
        dispatch(setFilterType(type));
    };

    const filteredAndSortedTransactions = React.useMemo(() => {
        if (!transactions) return [];

        let filtered = transactions;

        // Apply filter based on filterType
        if (filterType === 'inbound') {
            filtered = transactions.filter(item => item.status === 'Inbound');
        } else if (filterType === 'outbound') {
            filtered = transactions.filter(item => item.status === 'Outbound');
        }

        // Sort by ID in descending order
        return [...filtered].sort((a, b) => Number(b.id) - Number(a.id));
    }, [transactions, filterType]);

    const getProductImage = (item) => {
        try {
            if (item.product?.product_image?.length > 0) {
                const imageUrl = item.product.product_image[0].image_url;
                return imageUrl;
            }
            console.log("No product image found, returning default");
            return ItemImage;
        } catch (error) {
            console.error("Error fetching product image:", error);
            return ItemImage;
        }
    };

    const getTransactionStatus = (item) => {
        return item.status;
    };

    const getStatusClass = (item) => {
        const status = item.status || '';
        if (status === 'Inbound') {
            return Styles.inbound;
        }
        if (status === 'Outbound') {
            return Styles.outbound;
        }
        return '';
    };

    const getNoDataMessage = () => {
        switch (filterType) {
            case 'inbound':
                return 'No inbound transactions found';
            case 'outbound':
                return 'No outbound transactions found';
            default:
                return 'No transactions found';
        }
    };

    return (
        <div className={`${Styles.dashboard}`}>
            <div className={`${Styles.dashboard_heading}`}>
                <h2>Dashboard</h2>
            </div>

            <div className={`${Styles.stock}`}>
                <div className={`${Styles.inbound_stock}`}>
                    <div className={`${Styles.inbound}`} onClick={() => handleScanBarcode("inbound")}>
                        <p>INBOUND STOCK</p>
                        <img src={Inbound} alt="INBOUND STOCK" />
                    </div>
                </div>
                <div className={`${Styles.outbound_stock}`}>
                    <div className={`${Styles.outbound}`} onClick={() => handleScanBarcode("outbound")}>
                        <p>OUTBOUND STOCK</p>
                        <img src={Outbound} alt="OUTBOUND STOCK" />
                    </div>
                </div>
            </div>

            <div className={`${Styles.transactions_table}`}>
                <p>Recent transactions</p>
                <div className={`${Styles.transactions_button}`}>
                    <button className={filterType === "all" ? Styles.active : ""} onClick={() => handleFilter("all")}>
                        All Transactions
                    </button>
                    <button className={filterType === "inbound" ? Styles.active : ""} onClick={() => handleFilter("inbound")}>
                        Inbound Transactions
                    </button>
                    <button className={filterType === "outbound" ? Styles.active : ""} onClick={() => handleFilter("outbound")}>
                        Outbound Transactions
                    </button>
                </div>

                <div className={`${Styles.transactions_history}`}>
                    <div className={`${Styles.item_table}`}>
                        <table>
                            <thead>
                                <tr>
                                    <th className={`${Styles.first_row}`}>No.</th>
                                    <th>Product name</th>
                                    <th>Barcode number</th>
                                    <th>Quantity</th>
                                    <th>Status</th>
                                    <th>Order date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan="6" className={`${Styles.loader_Container}`}>
                                            <Loader size="medium" color="primary" />
                                        </td>
                                    </tr>
                                ) : error ? (
                                    <tr>
                                        <td colSpan="6" className={`${Styles.error_Message}`}>
                                            {error}
                                        </td>
                                    </tr>
                                ) : filteredAndSortedTransactions.length === 0 ? (
                                    <tr>
                                        <td colSpan="6" className={`${Styles.no_Data_Message}`}>
                                            {getNoDataMessage()}
                                        </td>
                                    </tr>
                                ) : (
                                    filteredAndSortedTransactions.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td className={`${Styles.first_row}`}>{index + 1}</td>
                                            <td className={`${Styles.name_product}`}>
                                                <div className={`${Styles.item_name}`}>
                                                    <img
                                                        src={getProductImage(item)}
                                                        alt={item.product_name}
                                                        className={`${Styles.item_icon}`}
                                                        onError={(e) => {
                                                            e.target.onerror = null;
                                                            e.target.src = ItemImage;
                                                        }}
                                                    />
                                                    <p className={`${Styles.product_name}`}>{item.name || 'N/A'}</p>
                                                </div>
                                            </td>
                                            <td>{item.barcode}</td>
                                            <td>{item?.quantity || 'N/A'}</td>
                                            <td>
                                                <span className={`${Styles.status} ${getStatusClass(item)}`}>
                                                    {getTransactionStatus(item)}
                                                </span>
                                            </td>
                                            <td>{item.order}</td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Dashboard;
